import React from 'react';
import moment from 'moment';
import DatePicker from '../../../component/element/DatePicker';
import Select from '../../../component/Select';

export default class PrintModal extends React.Component {
  zooms = [
    {label: 'วัน', value: 'Hours'},
    {label: 'สัปดาห์', value: 'Days'},
    {label: 'เดือน', value: 'Months'},
  ];

  constructor(props) {
    super(props);
    this.state = {
      start_page: 1,
      end_page: 1,
      zoom: 'Days',
      maxLevel: 3,
      start_date: moment(props.start_date || null).
          startOf('month'),
      end_date: moment(props.end_date || null).
          endOf('month'),
    };
    moment().weekday(1);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      start_page: nextProps.start_page,
      end_page: nextProps.end_page,
      zoom: nextProps.zoom,
      maxLevel: nextProps.maxLevel,
      start_date: moment(nextProps.start_date || null),
      end_date: moment(nextProps.end_date || null),
    });
  }

  onPrintCancel = () => {
    this.props.onPrintCancel && this.props.onPrintCancel();
  };

  onPrintSubmit = (e) => {
    e.preventDefault();
    const gantt_params = {
      show_task_cells: true,
      // zoom: this.state.zoom,
    };

    const print_params = {
      // skin: 'material',
      header: `
      <style>
        .remove_task_btn {
  background-color: #FF3860;
  color: #FFF;
  -ms-flex-align: center;
      align-items: center;
  border: 1px solid transparent;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
  width: 50%;
  margin-top: 10px;
  font-size: 18px;
  margin-left: 5px;
}
.remove_task_btn:hover {
  cursor: pointer;
}
.gantt_grid_head_add {
  display: none;
}
.manage-label {
  margin-left: 20px;
}
.gantt_last_cell {
  float: right;
}
.weekend { 
  background: lightgray !important;
}
div[aria-level="0"] {
  background: rgb(162,93,222) !important;
}
/* div[aria-level="0"] {
  background: rgb(162,93,222);
} */
div[aria-level="0"] .gantt_cell .gantt_tree_content {
  color: #FFF;
}
/* icon */
div[aria-level="0"] .gantt_cell .gantt_folder_open {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAMAAAApB0NrAAAAPFBMVEUAAAD////////////////////////////////////////////////////////////////////////////YSWgTAAAAE3RSTlMAAgMEBUBUV1hbXWNkbG+yt7r9+nHL6AAAAHlJREFUOMvtlN0KgCAMRqc1TUsre/93zeyHRRohFQSdi+9iO4zvagAe44Y4zsBKSvHS5gxpnnE4aBqMRRwA3EfE0djTkPLv/PnOBdQ0OM/sXEJDI3rnrs4VtnQpRKozPZB5J8DmgTrrvAzwDUdhoDs6V/6PTf4xO61Hx107JCeAfkcAAAAASUVORK5CYII=) !important;
  background-size: contain;
  width: 22px;
  height: 100%;
  margin-left: 10px;
  margin-right: 10px;
}
div[aria-level="0"] .gantt_cell .gantt_folder_closed {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAMAAAApB0NrAAAAPFBMVEUAAAD////////////////////////////////////////////////////////////////////////////YSWgTAAAAE3RSTlMAAgMEBUBUV1hbXWNkbG+yt7r9+nHL6AAAAHlJREFUOMvtlN0KgCAMRqc1TUsre/93zeyHRRohFQSdi+9iO4zvagAe44Y4zsBKSvHS5gxpnnE4aBqMRRwA3EfE0djTkPLv/PnOBdQ0OM/sXEJDI3rnrs4VtnQpRKozPZB5J8DmgTrrvAzwDUdhoDs6V/6PTf4xO61Hx107JCeAfkcAAAAASUVORK5CYII=) !important;
  background-size: contain;
  width: 22px;
  height: 100%;
  margin-left: 10px;
  margin-right: 10px;
}

div[aria-level="1"] .gantt_cell .gantt_folder_open {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAMAAAApB0NrAAABAlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD+Tsa+AAAAVXRSTlMAAQIDBAUGBwgKCwwODxMUFRgZGhwjJiovMDU3PUBGR0lLTE1QUVlcXmFrbXl8goOFi46Pm52eoqWmqqutt7m6vsDBw8jMzs/V19na4Onr7/H3+fv9rDYgHgAAARNJREFUGBnVwWk7AmEAhtHnTSFZQrZsWSIkawhDZSnK0nL//7/infmgZqaLr5yjP8ocdPBrpuVnSoRtyCfDIHH1azBITn3GgE5M/arAg/osAyX57GBF1XMMbMknhTWvnjcgKZ9IF9jXt3GgZeR3A9T0bQU4V0AWa1ieSOasAbwUA6pYd4UlSbEaPysaHQKf5TaDvD5irekdCkbRa0LeZqR4Ba4ELSNpjJC0rAlwBE+yDCGTsgw4gm5MUpKQTVkpcATcJszUMyGdlSEz1wRH/MoRv3KUy9dx3ecDLvBU8quSjnFlFDCDJyvXEa51BUzj2ZZrF9eCAkbxLMqV6ACNiIJOseoReWbL7cu4Qsxe8+NkRP/TF5HFpGn9KID+AAAAAElFTkSuQmCC) !important;
  background-size: contain;
  width: 22px;
  height: 100%;
  margin-left: 10px;
  margin-right: 10px;
}

div[aria-level="1"] .gantt_cell .gantt_folder_closed {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAMAAAApB0NrAAABAlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD+Tsa+AAAAVXRSTlMAAQIDBAUGBwgKCwwODxMUFRgZGhwjJiovMDU3PUBGR0lLTE1QUVlcXmFrbXl8goOFi46Pm52eoqWmqqutt7m6vsDBw8jMzs/V19na4Onr7/H3+fv9rDYgHgAAARNJREFUGBnVwWk7AmEAhtHnTSFZQrZsWSIkawhDZSnK0nL//7/infmgZqaLr5yjP8ocdPBrpuVnSoRtyCfDIHH1azBITn3GgE5M/arAg/osAyX57GBF1XMMbMknhTWvnjcgKZ9IF9jXt3GgZeR3A9T0bQU4V0AWa1ieSOasAbwUA6pYd4UlSbEaPysaHQKf5TaDvD5irekdCkbRa0LeZqR4Ba4ELSNpjJC0rAlwBE+yDCGTsgw4gm5MUpKQTVkpcATcJszUMyGdlSEz1wRH/MoRv3KUy9dx3ecDLvBU8quSjnFlFDCDJyvXEa51BUzj2ZZrF9eCAkbxLMqV6ACNiIJOseoReWbL7cu4Qsxe8+NkRP/TF5HFpGn9KID+AAAAAElFTkSuQmCC) !important;
  background-size: contain;
  width: 22px;
  height: 100%;
  margin-left: 10px;
  margin-right: 10px;
}
div[aria-level="2"] .gantt_cell .gantt_folder_open {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAMAAAApB0NrAAABL1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC7wylAAAAZHRSTlMAAQIDBAUGBwgNEBYXGBkaHB0eICEiJCUmJyouOzxAQkNERUZKTE1PUlRbXl9jZ2hrbG9wcXN1fouMj5idnqCjpaaorbC0tbe5urzBw8XOz9HT1dfZ2tze4OLk6Ovv8fX3+fv9KzKn+QAAAW9JREFUGBl1wQs7FGEAhuF3dhfRaqoth85oplItaxerpAMyMmKXmdQ4FM///w1dPmOZz8x9K8OtB0kS1F0VGg5IBVXlewlELd+fj4Ep5fGgOyZjfA+mdNMdWKsoVVmHqm74QbesnsoeG7LdhVFdMw6uLLNEyoipy7JJUxnzBLIkeMrwSWQ5wlOGz5EsIU1ltNiSpcW+MiJastyHEV0zBvdkC+mU1VPpsiXb0AqslpUqr8HKkDJKbc51RmSMdjnXLulKaQOShQaw3/S8ZgQ0FhL4XlJPG+qONLxNarsqOTOwpEs1mJVRmwsPD8O5mowG1JT6QuQohxPzWRf64blyTUC/jMcwoFy34JGMGXZVoMN7GcssqcAHPsrY4a0KvOOnjARfBV7xR8Y/XqjABH9lHPBaBd7wS8YnvqrAN5ZlPIXbylWFJzKc38SDyjEYc+DognvG6eLkM8vk4ilnri49PCbX8QNd6ZsOT7CchNN9Mv4DcPBm3VPma9UAAAAASUVORK5CYII=) !important;
  background-size: contain;
  width: 22px;
  height: 100%;
  margin-left: 10px;
  margin-right: 10px;
}

div[aria-level="2"] .gantt_cell .gantt_folder_closed {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAMAAAApB0NrAAABL1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC7wylAAAAZHRSTlMAAQIDBAUGBwgNEBYXGBkaHB0eICEiJCUmJyouOzxAQkNERUZKTE1PUlRbXl9jZ2hrbG9wcXN1fouMj5idnqCjpaaorbC0tbe5urzBw8XOz9HT1dfZ2tze4OLk6Ovv8fX3+fv9KzKn+QAAAW9JREFUGBl1wQs7FGEAhuF3dhfRaqoth85oplItaxerpAMyMmKXmdQ4FM///w1dPmOZz8x9K8OtB0kS1F0VGg5IBVXlewlELd+fj4Ep5fGgOyZjfA+mdNMdWKsoVVmHqm74QbesnsoeG7LdhVFdMw6uLLNEyoipy7JJUxnzBLIkeMrwSWQ5wlOGz5EsIU1ltNiSpcW+MiJastyHEV0zBvdkC+mU1VPpsiXb0AqslpUqr8HKkDJKbc51RmSMdjnXLulKaQOShQaw3/S8ZgQ0FhL4XlJPG+qONLxNarsqOTOwpEs1mJVRmwsPD8O5mowG1JT6QuQohxPzWRf64blyTUC/jMcwoFy34JGMGXZVoMN7GcssqcAHPsrY4a0KvOOnjARfBV7xR8Y/XqjABH9lHPBaBd7wS8YnvqrAN5ZlPIXbylWFJzKc38SDyjEYc+DognvG6eLkM8vk4ilnri49PCbX8QNd6ZsOT7CchNN9Mv4DcPBm3VPma9UAAAAASUVORK5CYII=) !important;
  background-size: contain;
  width: 22px;
  height: 100%;
  margin-left: 10px;
  margin-right: 10px;
}
div[aria-level="3"] .gantt_cell .gantt_file {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjBAMAAADs965qAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACXRSTlMACz5AaJHa3P0bK12NAAAAT0lEQVQokWNgIBcIGaMCIwGGyploIIEBXWTmBAZUHgODJUGhyUDjIycwdKKb1cDggSYyw4E+rjeAG2SJRygYbvzgcj0IoDkVhxBNXE8UAAB8+McLF7hZQQAAAABJRU5ErkJggg==) !important;
  background-size: contain;
  width: 22px;
  height: 100%;
  margin-left: 10px;
  margin-right: 10px;
}
.gantt_row[aria-level="0"] .gantt_cell:nth-child(2) {
  display: none;
}
.gantt_row[aria-level="0"] .gantt_cell:nth-child(3) {
  display: none;
}

.gantt_row[aria-level="1"] .gantt_cell:nth-child(2) {
  display: none;
}
.gantt_row[aria-level="1"] .gantt_cell:nth-child(3) {
  display: none;
}
${this.state.maxLevel == 3
          ? '.gantt_row[aria-level="2"] .gantt_cell:nth-child(2) {display: none;}.gantt_row[aria-level="2"] .gantt_cell:nth-child(3) {display: none;'
          : ''}

.parent_task {
  display: none;
}
.nested_task .gantt_add{
  display: none;
}
.template-items {
  margin-top: 30px;
  text-align: center;
}
.template-items > thead > tr > th {
  text-align: center;
}
.btn-danger {
  background: #FF3860 !important;
  color: white;
  font-size: 14px;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 15px;
  padding-right: 15px;
  border: none;
  border-radius: 5px;
}
.btn-danger:hover {
  cursor: pointer;
}

.holders-items {
  margin-top: 20px;
}
.holder-item  {
  margin-bottom: 10px;
}
.holder-item > span > button {
  background: #FF3860 !important;
  color: white;
  font-size: 14px;
  margin-left: 20px;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 15px;
  padding-right: 15px;
  border: none;
  border-radius: 5px;
}
.holder-item > span > button:hover {
  cursor: pointer;
}

.print-btn {
  background: #01D1B2 !important;
  color: white;
  font-size: 14px;
  margin-left: 10px;
  padding-top: 1px;
  padding-bottom: 1px;
  padding-left: 15px;
  padding-right: 15px;
  border: none;
  border-radius: 5px;
}
.print-btn:hover {
  cursor: pointer;
}
.gantt_scale_cell {
  font-size: 10px;
}
.modal-cover {
  background-color: rgba(000, 0, 0, 0.1);
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
}
.close-btn {
  position: absolute;
  right: 10px;
  padding: 10px;
  background: #FFF;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
}
.close-btn:hover {
  cursor: pointer;
  color: #FFF;
  background: #dbdbdb;
}
.add_holder_btn_set {
   background: #FFF !important;
  color: #454545 !important;
  border: 1px solid #CECECE !important;
}
.submit_task_btn {
  background-color: #00d1b2;
  color: #FFF;
  -ms-flex-align: center;
      align-items: center;
  border: 1px solid transparent;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
  width: 50%;
  margin-top: 10px;
  font-size: 18px;
}
.submit_task_btn:hover {
  cursor: pointer;
}
.input_task {
  padding: 10px;
  font-size: 16px;
}
.title {
  color: #6b6b6b;
  font-family: Arial;
  margin-top: 0px;
}
.color-picker-wrapper {
  margin-top: 20px;
  text-align: center;
  padding-left: 30px;
  margin-bottom: 30px;
}

.gantt_task_row {
  background-color: #ebebeb!important;
}

.color-item {
  width: 3…
      </style>
      `,
      // moment default first day of week is Sunday, we customize this.
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      start: this.state.start_date.format('DD-MM-YYYY'),
      end: this.state.end_date.format('DD-MM-YYYY'),
      // name: `export-page-${this.state.start_page}.pdf`,
      start_page: this.state.start_page,
      end_page: this.state.end_page,
    };

    this.props.onPrintSubmit &&
    this.props.onPrintSubmit(gantt_params, print_params);
  };

  onDateChange = (field) => (value) => {
    console.log('print date', field, value);
    this.setState({[field]: moment(value, 'DD/MM/YYYY')});
  };

  onZoomChange = (e) => {
    this.setState({zoom: e.target.value});
  };

  shortcutDate = shortcut => e => {
    switch (shortcut) {
      case 'this-week':
        this.setState({
          start_date: moment().startOf('week'),
          end_date: moment().endOf('week'),
        });
        break;
      case 'this-month':
        this.setState({
          start_date: moment().startOf('month'),
          end_date: moment().endOf('month'),
        });
        break;
      case 'past-3-month':
        this.setState({
          start_date: moment().
              subtract(3, 'month').
              startOf('month')
          ,
          end_date: moment().endOf('month'),
        });
        break;
      default:
        break;
    }
  };

  render() {
    if (this.props.show === true) {

      const start_date = this.state.start_date.format('DD/MM/YYYY');
      const end_date = this.state.end_date.format('DD/MM/YYYY');
      const {start_page, end_page} = this.state;
      return (
          <div className="modal-cover">
            <div className="template-modal"
                 style={{
                   width: '90%', maxWidth: 600,
                   left: '50%', transform: 'translateX(-50%)',
                 }}>
              <h2 className="title">ตั้งค่าการพิมพ์</h2>
              <br />
              <form onSubmit={this.onPrintSubmit}>
                {/* <div className="row form-group">
                  <label className="control-label col-xs-3">การแสดงผล</label>
                  <select className=" col-xs-9"
                          onChange={this.onZoomChange}
                          value={this.state.zoom}>
                    {this.zooms.map((zoom, i) => <option key={i}
                                                         value={zoom.value}>{zoom.label}</option>)}
                  </select>

                </div>*/}

                <div className="row form-group">

                  <label
                      className="control-label col-xs-3"
                      style={{'line-height': 34}}>ทางลัด:</label>
                  <div className="col-xs-9 text-left">
                    <div className="">
                      <button type="button" className="btn btn-info"
                              onClick={this.shortcutDate(
                                  'this-week')}>สัปดาห์นี้
                      </button>
                      {' '}
                      <button type="button" className="btn btn-info"
                              onClick={this.shortcutDate('this-month')}>เดือนนี้
                      </button>
                      {' '}
                      <button type="button" className="btn btn-info"
                              onClick={this.shortcutDate('past-3-month')}>3
                                                                          เดือนก่อน
                      </button>
                      {' '}
                    </div>
                  </div>
                </div>

                <div className="row form-group">

                  <label
                      className="control-label col-xs-3"
                      style={{'line-height': 34}}>ตั้งแต่วันที่:</label>
                  <div className="col-xs-9 text-left">
                    <DatePicker
                        style={{'display': 'inline-block'}}
                        showIcon={true}
                        showFooter={true}
                        popPlacement="bottom"
                        // buddhistEra
                        value={start_date}
                        onChange={this.onDateChange('start_date')} />
                  </div>
                </div>

                <div className="row form-group">
                  <label className="control-label col-xs-3"
                         style={{'line-height': 34}}>ถึงวันที่:</label>
                  <div className="col-xs-9 text-left">
                    <DatePicker
                        style={{'display': 'inline-block'}}
                        showIcon={true}
                        showFooter={true}
                        popPlacement="bottom"
                        // buddhistEra
                        value={end_date}
                        onChange={this.onDateChange('end_date')} />
                  </div>
                </div>
                <br />
                <div
                    className="row form-group react-flex-v2 react-flex-v2--align-items-center">
                  <label className="control-label col-xs-3"
                         style={{'line-height': 34}}>หน้า:</label>
                  <div className="col-xs-3 text-left">
                    <input
                        className="form-control"
                        value={start_page}
                        onChange={e => this.setState(
                            {start_page: e.target.value})} />
                  </div>
                  <div className="col-xs-1 text-left">
                    ถึง
                  </div>
                  <div className="col-xs-3 text-left">
                    <input
                        className="form-control"
                        value={end_page}
                        onChange={e => this.setState(
                            {end_page: e.target.value})} />
                  </div>
                </div>
                <br />
                <button type="submit" className="btn btn-primary">
                  <span className="fa fa-print" />{' '}
                  พิมพ์
                </button>
                {' '}
                <button type="button" className="btn btn-default"
                        onClick={this.onPrintCancel}>
                  <span className="fa fa-times" />{' '}
                  ยกเลิก
                </button>
              </form>
            </div>
          </div>
      );
    } else {
      return (
          <div></div>
      );
    }
  }
}


// WEBPACK FOOTER //
// ./src/view/workdoc/plan/PrintModal.js